@file:OptIn(InternalResourceApi::class)

package gamerlogue.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gamerlogue.sharedui.generated.resources/"

@delegate:ResourceContentHash(-1_088_915_592)
internal val Res.string.game_category__update: StringResource by lazy {
      StringResource("string:game_category__update", "game_category__update", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12222, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11434, 37),
      ))
    }

@delegate:ResourceContentHash(-1_849_779_328)
internal val Res.string.game_mode__battle_royale: StringResource by lazy {
      StringResource("string:game_mode__battle_royale", "game_mode__battle_royale", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12272, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11472, 52),
      ))
    }

@delegate:ResourceContentHash(1_010_117_618)
internal val Res.string.game_mode__cooperative: StringResource by lazy {
      StringResource("string:game_mode__cooperative", "game_mode__cooperative", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12325, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11525, 46),
      ))
    }

@delegate:ResourceContentHash(-338_948_738)
internal val Res.string.game_mode__mmo: StringResource by lazy {
      StringResource("string:game_mode__mmo", "game_mode__mmo", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12372, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11572, 70),
      ))
    }

@delegate:ResourceContentHash(-1_721_049_837)
internal val Res.string.game_mode__multiplayer: StringResource by lazy {
      StringResource("string:game_mode__multiplayer", "game_mode__multiplayer", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12443, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11643, 46),
      ))
    }

@delegate:ResourceContentHash(1_966_997_373)
internal val Res.string.game_mode__single_player: StringResource by lazy {
      StringResource("string:game_mode__single_player", "game_mode__single_player", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12494, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11690, 52),
      ))
    }

@delegate:ResourceContentHash(272_821_990)
internal val Res.string.game_mode__split_screen: StringResource by lazy {
      StringResource("string:game_mode__split_screen", "game_mode__split_screen", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12551, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11743, 47),
      ))
    }

@delegate:ResourceContentHash(-1_518_330_706)
internal val Res.string.game_mode__unknown: StringResource by lazy {
      StringResource("string:game_mode__unknown", "game_mode__unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12607, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11791, 50),
      ))
    }

@delegate:ResourceContentHash(2_141_128_800)
internal val Res.string.game_status__alpha: StringResource by lazy {
      StringResource("string:game_status__alpha", "game_status__alpha", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12674, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11842, 34),
      ))
    }

@delegate:ResourceContentHash(984_150_464)
internal val Res.string.game_status__beta: StringResource by lazy {
      StringResource("string:game_status__beta", "game_status__beta", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12709, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11877, 33),
      ))
    }

@delegate:ResourceContentHash(227_017_526)
internal val Res.string.game_status__cancelled: StringResource by lazy {
      StringResource("string:game_status__cancelled", "game_status__cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12743, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11911, 42),
      ))
    }

@delegate:ResourceContentHash(361_373_319)
internal val Res.string.game_status__delisted: StringResource by lazy {
      StringResource("string:game_status__delisted", "game_status__delisted", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12790, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11954, 41),
      ))
    }

@delegate:ResourceContentHash(1_975_887_474)
internal val Res.string.game_status__early_access: StringResource by lazy {
      StringResource("string:game_status__early_access", "game_status__early_access", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12856, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11996, 49),
      ))
    }

@delegate:ResourceContentHash(-1_681_754_432)
internal val Res.string.game_status__offline: StringResource by lazy {
      StringResource("string:game_status__offline", "game_status__offline", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12914, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12046, 40),
      ))
    }

@delegate:ResourceContentHash(769_234_688)
internal val Res.string.game_status__released: StringResource by lazy {
      StringResource("string:game_status__released", "game_status__released", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12955, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12087, 41),
      ))
    }

@delegate:ResourceContentHash(847_127_380)
internal val Res.string.game_status__rumored: StringResource by lazy {
      StringResource("string:game_status__rumored", "game_status__rumored", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13001, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12129, 40),
      ))
    }

@delegate:ResourceContentHash(1_097_908_350)
internal val Res.string.game_status__unknown: StringResource by lazy {
      StringResource("string:game_status__unknown", "game_status__unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13050, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12170, 48),
      ))
    }

@delegate:ResourceContentHash(391_512_697)
internal val Res.string.game_time_to_beat: StringResource by lazy {
      StringResource("string:game_time_to_beat", "game_time_to_beat", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13103, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12219, 41),
      ))
    }

@delegate:ResourceContentHash(993_343_671)
internal val Res.string.gamelist__company_role_developer: StringResource by lazy {
      StringResource("string:gamelist__company_role_developer", "gamelist__company_role_developer", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13169, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12261, 52),
      ))
    }

@delegate:ResourceContentHash(442_321_760)
internal val Res.string.gamelist__company_role_porting: StringResource by lazy {
      StringResource("string:gamelist__company_role_porting", "gamelist__company_role_porting", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13226, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12314, 50),
      ))
    }

@delegate:ResourceContentHash(-920_461_248)
internal val Res.string.gamelist__company_role_publisher: StringResource by lazy {
      StringResource("string:gamelist__company_role_publisher", "gamelist__company_role_publisher", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13277, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12365, 52),
      ))
    }

@delegate:ResourceContentHash(-2_110_214_283)
internal val Res.string.gamelist__company_role_supporting: StringResource by lazy {
      StringResource("string:gamelist__company_role_supporting", "gamelist__company_role_supporting", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13330, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12418, 53),
      ))
    }

@delegate:ResourceContentHash(-1_693_184_108)
internal val Res.string.gamelist__critics_rating: StringResource by lazy {
      StringResource("string:gamelist__critics_rating", "gamelist__critics_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13384, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12472, 52),
      ))
    }

@delegate:ResourceContentHash(-28_462_760)
internal val Res.string.gamelist__date_any: StringResource by lazy {
      StringResource("string:gamelist__date_any", "gamelist__date_any", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13445, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12525, 38),
      ))
    }

@delegate:ResourceContentHash(-1_055_862_229)
internal val Res.string.gamelist__empty_hint: StringResource by lazy {
      StringResource("string:gamelist__empty_hint", "gamelist__empty_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13492, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12564, 80),
      ))
    }

@delegate:ResourceContentHash(1_827_773_862)
internal val Res.string.gamelist__filter_categories: StringResource by lazy {
      StringResource("string:gamelist__filter_categories", "gamelist__filter_categories", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13569, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12645, 55),
      ))
    }

@delegate:ResourceContentHash(-1_804_643_305)
internal val Res.string.gamelist__filter_companies: StringResource by lazy {
      StringResource("string:gamelist__filter_companies", "gamelist__filter_companies", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13625, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12701, 62),
      ))
    }

@delegate:ResourceContentHash(1_673_382_349)
internal val Res.string.gamelist__filter_company_roles: StringResource by lazy {
      StringResource("string:gamelist__filter_company_roles", "gamelist__filter_company_roles", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13692, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12764, 54),
      ))
    }

@delegate:ResourceContentHash(2_042_860_200)
internal val Res.string.gamelist__filter_engines: StringResource by lazy {
      StringResource("string:gamelist__filter_engines", "gamelist__filter_engines", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13751, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12819, 48),
      ))
    }

@delegate:ResourceContentHash(215_493_876)
internal val Res.string.gamelist__filter_franchises: StringResource by lazy {
      StringResource("string:gamelist__filter_franchises", "gamelist__filter_franchises", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13804, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12868, 51),
      ))
    }

@delegate:ResourceContentHash(1_296_156_617)
internal val Res.string.gamelist__filter_keywords: StringResource by lazy {
      StringResource("string:gamelist__filter_keywords", "gamelist__filter_keywords", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13852, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12920, 45),
      ))
    }

@delegate:ResourceContentHash(-1_263_405_668)
internal val Res.string.gamelist__filter_platforms: StringResource by lazy {
      StringResource("string:gamelist__filter_platforms", "gamelist__filter_platforms", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13906, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12966, 46),
      ))
    }

@delegate:ResourceContentHash(1_365_573_790)
internal val Res.string.gamelist__filter_player_perspectives: StringResource by lazy {
      StringResource("string:gamelist__filter_player_perspectives", "gamelist__filter_player_perspectives", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13957, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13013, 68),
      ))
    }

@delegate:ResourceContentHash(1_071_878_591)
internal val Res.string.gamelist__filter_status: StringResource by lazy {
      StringResource("string:gamelist__filter_status", "gamelist__filter_status", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14018, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13082, 55),
      ))
    }

@delegate:ResourceContentHash(225_748_912)
internal val Res.string.gamelist__filter_time_to_beat: StringResource by lazy {
      StringResource("string:gamelist__filter_time_to_beat", "gamelist__filter_time_to_beat", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14070, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13138, 53),
      ))
    }

@delegate:ResourceContentHash(-1_579_398_061)
internal val Res.string.gamelist__filter_title: StringResource by lazy {
      StringResource("string:gamelist__filter_title", "gamelist__filter_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14140, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13192, 50),
      ))
    }

@delegate:ResourceContentHash(-1_871_306_248)
internal val Res.string.gamelist__filter_type_to_search: StringResource by lazy {
      StringResource("string:gamelist__filter_type_to_search", "gamelist__filter_type_to_search", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14195, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13243, 59),
      ))
    }

@delegate:ResourceContentHash(725_312_216)
internal val Res.string.gamelist__grid_columns: StringResource by lazy {
      StringResource("string:gamelist__grid_columns", "gamelist__grid_columns", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14259, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13303, 46),
      ))
    }

@delegate:ResourceContentHash(-59_999_819)
internal val Res.string.gamelist__group_game: StringResource by lazy {
      StringResource("string:gamelist__group_game", "gamelist__group_game", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14314, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13350, 44),
      ))
    }

@delegate:ResourceContentHash(1_934_905_504)
internal val Res.string.gamelist__group_library: StringResource by lazy {
      StringResource("string:gamelist__group_library", "gamelist__group_library", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14363, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13395, 47),
      ))
    }

@delegate:ResourceContentHash(713_878_528)
internal val Res.string.gamelist__hours_range: StringResource by lazy {
      StringResource("string:gamelist__hours_range", "gamelist__hours_range", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14522, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13550, 49),
      ))
    }

@delegate:ResourceContentHash(-1_497_989_532)
internal val Res.string.gamelist__hours_range_open: StringResource by lazy {
      StringResource("string:gamelist__hours_range_open", "gamelist__hours_range_open", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14415, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13443, 54),
      ))
    }

@delegate:ResourceContentHash(-1_112_684_215)
internal val Res.string.gamelist__hours_range_up_to: StringResource by lazy {
      StringResource("string:gamelist__hours_range_up_to", "gamelist__hours_range_up_to", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14466, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13498, 51),
      ))
    }

@delegate:ResourceContentHash(-1_968_041_720)
internal val Res.string.gamelist__library_sort_created: StringResource by lazy {
      StringResource("string:gamelist__library_sort_created", "gamelist__library_sort_created", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14572, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13600, 54),
      ))
    }

@delegate:ResourceContentHash(-1_075_688_864)
internal val Res.string.gamelist__library_sort_updated: StringResource by lazy {
      StringResource("string:gamelist__library_sort_updated", "gamelist__library_sort_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14635, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13655, 54),
      ))
    }

@delegate:ResourceContentHash(-2_040_426_596)
internal val Res.string.gamelist__max_hours: StringResource by lazy {
      StringResource("string:gamelist__max_hours", "gamelist__max_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14694, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13710, 39),
      ))
    }

@delegate:ResourceContentHash(1_057_903_028)
internal val Res.string.gamelist__min_hours: StringResource by lazy {
      StringResource("string:gamelist__min_hours", "gamelist__min_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14738, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13750, 39),
      ))
    }

@delegate:ResourceContentHash(1_426_565_645)
internal val Res.string.gamelist__my_rating: StringResource by lazy {
      StringResource("string:gamelist__my_rating", "gamelist__my_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14782, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13790, 39),
      ))
    }

@delegate:ResourceContentHash(-1_910_734_123)
internal val Res.string.gamelist__not_owned: StringResource by lazy {
      StringResource("string:gamelist__not_owned", "gamelist__not_owned", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14826, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13830, 39),
      ))
    }

@delegate:ResourceContentHash(593_208_352)
internal val Res.string.gamelist__release_all: StringResource by lazy {
      StringResource("string:gamelist__release_all", "gamelist__release_all", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14874, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13870, 33),
      ))
    }

@delegate:ResourceContentHash(-249_468_870)
internal val Res.string.gamelist__release_released: StringResource by lazy {
      StringResource("string:gamelist__release_released", "gamelist__release_released", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14912, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13904, 46),
      ))
    }

@delegate:ResourceContentHash(-504_763_864)
internal val Res.string.gamelist__release_status: StringResource by lazy {
      StringResource("string:gamelist__release_status", "gamelist__release_status", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14967, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13951, 52),
      ))
    }

@delegate:ResourceContentHash(1_883_620_294)
internal val Res.string.gamelist__release_upcoming: StringResource by lazy {
      StringResource("string:gamelist__release_upcoming", "gamelist__release_upcoming", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15020, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14004, 46),
      ))
    }

@delegate:ResourceContentHash(393_439_823)
internal val Res.string.gamelist__release_year: StringResource by lazy {
      StringResource("string:gamelist__release_year", "gamelist__release_year", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15067, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14051, 46),
      ))
    }

@delegate:ResourceContentHash(-155_832_627)
internal val Res.string.gamelist__remove_filter: StringResource by lazy {
      StringResource("string:gamelist__remove_filter", "gamelist__remove_filter", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15118, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14098, 47),
      ))
    }

@delegate:ResourceContentHash(-295_302_617)
internal val Res.string.gamelist__reset: StringResource by lazy {
      StringResource("string:gamelist__reset", "gamelist__reset", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15166, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14146, 31),
      ))
    }

@delegate:ResourceContentHash(174_275_223)
internal val Res.string.gamelist__search_companies: StringResource by lazy {
      StringResource("string:gamelist__search_companies", "gamelist__search_companies", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15206, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14178, 62),
      ))
    }

@delegate:ResourceContentHash(-1_453_883_116)
internal val Res.string.gamelist__search_engines: StringResource by lazy {
      StringResource("string:gamelist__search_engines", "gamelist__search_engines", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15269, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14241, 60),
      ))
    }

@delegate:ResourceContentHash(1_730_173_525)
internal val Res.string.gamelist__search_franchises: StringResource by lazy {
      StringResource("string:gamelist__search_franchises", "gamelist__search_franchises", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15326, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14302, 63),
      ))
    }

@delegate:ResourceContentHash(1_426_420_358)
internal val Res.string.gamelist__search_keywords: StringResource by lazy {
      StringResource("string:gamelist__search_keywords", "gamelist__search_keywords", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15390, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14366, 61),
      ))
    }

@delegate:ResourceContentHash(1_924_230_670)
internal val Res.string.gamelist__sort_dir_asc: StringResource by lazy {
      StringResource("string:gamelist__sort_dir_asc", "gamelist__sort_dir_asc", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15460, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14428, 50),
      ))
    }

@delegate:ResourceContentHash(-601_842_300)
internal val Res.string.gamelist__sort_dir_desc: StringResource by lazy {
      StringResource("string:gamelist__sort_dir_desc", "gamelist__sort_dir_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15511, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14479, 55),
      ))
    }

@delegate:ResourceContentHash(1_274_004_678)
internal val Res.string.gamelist__sort_direction: StringResource by lazy {
      StringResource("string:gamelist__sort_direction", "gamelist__sort_direction", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15567, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14535, 44),
      ))
    }

@delegate:ResourceContentHash(783_197_131)
internal val Res.string.gamelist__sort_disabled_search: StringResource by lazy {
      StringResource("string:gamelist__sort_disabled_search", "gamelist__sort_disabled_search", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15608, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14580, 90),
      ))
    }

@delegate:ResourceContentHash(1_662_069_063)
internal val Res.string.gamelist__sort_field: StringResource by lazy {
      StringResource("string:gamelist__sort_field", "gamelist__sort_field", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15996, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14948, 44),
      ))
    }

@delegate:ResourceContentHash(-1_426_345_267)
internal val Res.string.gamelist__sort_field_critics_rating: StringResource by lazy {
      StringResource("string:gamelist__sort_field_critics_rating", "gamelist__sort_field_critics_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15715, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14671, 63),
      ))
    }

@delegate:ResourceContentHash(-1_920_083_597)
internal val Res.string.gamelist__sort_field_name: StringResource by lazy {
      StringResource("string:gamelist__sort_field_name", "gamelist__sort_field_name", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15775, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14735, 41),
      ))
    }

@delegate:ResourceContentHash(736_053_748)
internal val Res.string.gamelist__sort_field_popularity: StringResource by lazy {
      StringResource("string:gamelist__sort_field_popularity", "gamelist__sort_field_popularity", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15817, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14777, 55),
      ))
    }

@delegate:ResourceContentHash(437_633_162)
internal val Res.string.gamelist__sort_field_release_date: StringResource by lazy {
      StringResource("string:gamelist__sort_field_release_date", "gamelist__sort_field_release_date", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15873, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14833, 57),
      ))
    }

@delegate:ResourceContentHash(1_137_213_929)
internal val Res.string.gamelist__sort_field_user_rating: StringResource by lazy {
      StringResource("string:gamelist__sort_field_user_rating", "gamelist__sort_field_user_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15939, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14891, 56),
      ))
    }

@delegate:ResourceContentHash(731_094_326)
internal val Res.string.gamelist__user_rating: StringResource by lazy {
      StringResource("string:gamelist__user_rating", "gamelist__user_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16041, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14993, 45),
      ))
    }

@delegate:ResourceContentHash(1_482_664_209)
internal val Res.string.gamelist__year_any: StringResource by lazy {
      StringResource("string:gamelist__year_any", "gamelist__year_any", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16095, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15039, 38),
      ))
    }

@delegate:ResourceContentHash(-23_772_821)
internal val Res.string.genre__adventure: StringResource by lazy {
      StringResource("string:genre__adventure", "genre__adventure", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16142, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15078, 36),
      ))
    }

@delegate:ResourceContentHash(892_733_408)
internal val Res.string.genre__arcade: StringResource by lazy {
      StringResource("string:genre__arcade", "genre__arcade", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16179, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15115, 29),
      ))
    }

@delegate:ResourceContentHash(-1_243_053_717)
internal val Res.string.genre__card_board: StringResource by lazy {
      StringResource("string:genre__card_board", "genre__card_board", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16209, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15145, 49),
      ))
    }

@delegate:ResourceContentHash(601_949_994)
internal val Res.string.genre__fighting: StringResource by lazy {
      StringResource("string:genre__fighting", "genre__fighting", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16267, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15195, 35),
      ))
    }

@delegate:ResourceContentHash(407_800_525)
internal val Res.string.genre__hack_and_slash: StringResource by lazy {
      StringResource("string:genre__hack_and_slash", "genre__hack_and_slash", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16307, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15231, 65),
      ))
    }

@delegate:ResourceContentHash(406_358_784)
internal val Res.string.genre__indie: StringResource by lazy {
      StringResource("string:genre__indie", "genre__indie", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16393, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15297, 28),
      ))
    }

@delegate:ResourceContentHash(1_843_017_056)
internal val Res.string.genre__moba: StringResource by lazy {
      StringResource("string:genre__moba", "genre__moba", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16422, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15326, 27),
      ))
    }

@delegate:ResourceContentHash(-712_041_802)
internal val Res.string.genre__music: StringResource by lazy {
      StringResource("string:genre__music", "genre__music", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16450, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15354, 28),
      ))
    }

@delegate:ResourceContentHash(334_948_725)
internal val Res.string.genre__pinball: StringResource by lazy {
      StringResource("string:genre__pinball", "genre__pinball", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16479, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15383, 34),
      ))
    }

@delegate:ResourceContentHash(-156_905_728)
internal val Res.string.genre__platform: StringResource by lazy {
      StringResource("string:genre__platform", "genre__platform", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16514, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15418, 35),
      ))
    }

@delegate:ResourceContentHash(-1_668_940_950)
internal val Res.string.genre__point_and_click: StringResource by lazy {
      StringResource("string:genre__point_and_click", "genre__point_and_click", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16550, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15454, 50),
      ))
    }

@delegate:ResourceContentHash(1_975_632_103)
internal val Res.string.genre__puzzle: StringResource by lazy {
      StringResource("string:genre__puzzle", "genre__puzzle", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16601, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15505, 29),
      ))
    }

@delegate:ResourceContentHash(2_038_976_385)
internal val Res.string.genre__quiz: StringResource by lazy {
      StringResource("string:genre__quiz", "genre__quiz", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16635, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15535, 35),
      ))
    }

@delegate:ResourceContentHash(1_345_064_051)
internal val Res.string.genre__racing: StringResource by lazy {
      StringResource("string:genre__racing", "genre__racing", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16675, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15571, 29),
      ))
    }

@delegate:ResourceContentHash(757_610_570)
internal val Res.string.genre__rpg: StringResource by lazy {
      StringResource("string:genre__rpg", "genre__rpg", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16705, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15601, 50),
      ))
    }

@delegate:ResourceContentHash(-1_703_523_615)
internal val Res.string.genre__rts: StringResource by lazy {
      StringResource("string:genre__rts", "genre__rts", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16752, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15652, 50),
      ))
    }

@delegate:ResourceContentHash(-1_370_790_501)
internal val Res.string.genre__shooter: StringResource by lazy {
      StringResource("string:genre__shooter", "genre__shooter", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16811, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15703, 34),
      ))
    }

@delegate:ResourceContentHash(-354_847_827)
internal val Res.string.genre__simulation: StringResource by lazy {
      StringResource("string:genre__simulation", "genre__simulation", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16850, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15738, 41),
      ))
    }

@delegate:ResourceContentHash(-572_439_264)
internal val Res.string.genre__sport: StringResource by lazy {
      StringResource("string:genre__sport", "genre__sport", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16892, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15780, 28),
      ))
    }

@delegate:ResourceContentHash(1_007_028_663)
internal val Res.string.genre__strategy: StringResource by lazy {
      StringResource("string:genre__strategy", "genre__strategy", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16921, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15809, 35),
      ))
    }

@delegate:ResourceContentHash(-1_677_358_103)
internal val Res.string.genre__tactical: StringResource by lazy {
      StringResource("string:genre__tactical", "genre__tactical", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16957, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15845, 35),
      ))
    }

@delegate:ResourceContentHash(1_435_941_995)
internal val Res.string.genre__tbs: StringResource by lazy {
      StringResource("string:genre__tbs", "genre__tbs", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16993, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15881, 54),
      ))
    }

@delegate:ResourceContentHash(1_919_330_001)
internal val Res.string.genre__unknown: StringResource by lazy {
      StringResource("string:genre__unknown", "genre__unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17044, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15936, 34),
      ))
    }

@delegate:ResourceContentHash(942_927_104)
internal val Res.string.genre__visual_novel: StringResource by lazy {
      StringResource("string:genre__visual_novel", "genre__visual_novel", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17083, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15971, 43),
      ))
    }

@delegate:ResourceContentHash(-139_740_117)
internal val Res.string.home__empty_section: StringResource by lazy {
      StringResource("string:home__empty_section", "home__empty_section", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17127, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16015, 51),
      ))
    }

@delegate:ResourceContentHash(-1_625_262_006)
internal val Res.string.home__events: StringResource by lazy {
      StringResource("string:home__events", "home__events", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17187, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16067, 28),
      ))
    }

@delegate:ResourceContentHash(-246_182_045)
internal val Res.string.home__most_loved_games: StringResource by lazy {
      StringResource("string:home__most_loved_games", "home__most_loved_games", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17216, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16096, 46),
      ))
    }

@delegate:ResourceContentHash(578_895_755)
internal val Res.string.home__popular_games: StringResource by lazy {
      StringResource("string:home__popular_games", "home__popular_games", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17263, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16143, 39),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("game_category__update", Res.string.game_category__update)
  map.put("game_mode__battle_royale", Res.string.game_mode__battle_royale)
  map.put("game_mode__cooperative", Res.string.game_mode__cooperative)
  map.put("game_mode__mmo", Res.string.game_mode__mmo)
  map.put("game_mode__multiplayer", Res.string.game_mode__multiplayer)
  map.put("game_mode__single_player", Res.string.game_mode__single_player)
  map.put("game_mode__split_screen", Res.string.game_mode__split_screen)
  map.put("game_mode__unknown", Res.string.game_mode__unknown)
  map.put("game_status__alpha", Res.string.game_status__alpha)
  map.put("game_status__beta", Res.string.game_status__beta)
  map.put("game_status__cancelled", Res.string.game_status__cancelled)
  map.put("game_status__delisted", Res.string.game_status__delisted)
  map.put("game_status__early_access", Res.string.game_status__early_access)
  map.put("game_status__offline", Res.string.game_status__offline)
  map.put("game_status__released", Res.string.game_status__released)
  map.put("game_status__rumored", Res.string.game_status__rumored)
  map.put("game_status__unknown", Res.string.game_status__unknown)
  map.put("game_time_to_beat", Res.string.game_time_to_beat)
  map.put("gamelist__company_role_developer", Res.string.gamelist__company_role_developer)
  map.put("gamelist__company_role_porting", Res.string.gamelist__company_role_porting)
  map.put("gamelist__company_role_publisher", Res.string.gamelist__company_role_publisher)
  map.put("gamelist__company_role_supporting", Res.string.gamelist__company_role_supporting)
  map.put("gamelist__critics_rating", Res.string.gamelist__critics_rating)
  map.put("gamelist__date_any", Res.string.gamelist__date_any)
  map.put("gamelist__empty_hint", Res.string.gamelist__empty_hint)
  map.put("gamelist__filter_categories", Res.string.gamelist__filter_categories)
  map.put("gamelist__filter_companies", Res.string.gamelist__filter_companies)
  map.put("gamelist__filter_company_roles", Res.string.gamelist__filter_company_roles)
  map.put("gamelist__filter_engines", Res.string.gamelist__filter_engines)
  map.put("gamelist__filter_franchises", Res.string.gamelist__filter_franchises)
  map.put("gamelist__filter_keywords", Res.string.gamelist__filter_keywords)
  map.put("gamelist__filter_platforms", Res.string.gamelist__filter_platforms)
  map.put("gamelist__filter_player_perspectives", Res.string.gamelist__filter_player_perspectives)
  map.put("gamelist__filter_status", Res.string.gamelist__filter_status)
  map.put("gamelist__filter_time_to_beat", Res.string.gamelist__filter_time_to_beat)
  map.put("gamelist__filter_title", Res.string.gamelist__filter_title)
  map.put("gamelist__filter_type_to_search", Res.string.gamelist__filter_type_to_search)
  map.put("gamelist__grid_columns", Res.string.gamelist__grid_columns)
  map.put("gamelist__group_game", Res.string.gamelist__group_game)
  map.put("gamelist__group_library", Res.string.gamelist__group_library)
  map.put("gamelist__hours_range", Res.string.gamelist__hours_range)
  map.put("gamelist__hours_range_open", Res.string.gamelist__hours_range_open)
  map.put("gamelist__hours_range_up_to", Res.string.gamelist__hours_range_up_to)
  map.put("gamelist__library_sort_created", Res.string.gamelist__library_sort_created)
  map.put("gamelist__library_sort_updated", Res.string.gamelist__library_sort_updated)
  map.put("gamelist__max_hours", Res.string.gamelist__max_hours)
  map.put("gamelist__min_hours", Res.string.gamelist__min_hours)
  map.put("gamelist__my_rating", Res.string.gamelist__my_rating)
  map.put("gamelist__not_owned", Res.string.gamelist__not_owned)
  map.put("gamelist__release_all", Res.string.gamelist__release_all)
  map.put("gamelist__release_released", Res.string.gamelist__release_released)
  map.put("gamelist__release_status", Res.string.gamelist__release_status)
  map.put("gamelist__release_upcoming", Res.string.gamelist__release_upcoming)
  map.put("gamelist__release_year", Res.string.gamelist__release_year)
  map.put("gamelist__remove_filter", Res.string.gamelist__remove_filter)
  map.put("gamelist__reset", Res.string.gamelist__reset)
  map.put("gamelist__search_companies", Res.string.gamelist__search_companies)
  map.put("gamelist__search_engines", Res.string.gamelist__search_engines)
  map.put("gamelist__search_franchises", Res.string.gamelist__search_franchises)
  map.put("gamelist__search_keywords", Res.string.gamelist__search_keywords)
  map.put("gamelist__sort_dir_asc", Res.string.gamelist__sort_dir_asc)
  map.put("gamelist__sort_dir_desc", Res.string.gamelist__sort_dir_desc)
  map.put("gamelist__sort_direction", Res.string.gamelist__sort_direction)
  map.put("gamelist__sort_disabled_search", Res.string.gamelist__sort_disabled_search)
  map.put("gamelist__sort_field", Res.string.gamelist__sort_field)
  map.put("gamelist__sort_field_critics_rating", Res.string.gamelist__sort_field_critics_rating)
  map.put("gamelist__sort_field_name", Res.string.gamelist__sort_field_name)
  map.put("gamelist__sort_field_popularity", Res.string.gamelist__sort_field_popularity)
  map.put("gamelist__sort_field_release_date", Res.string.gamelist__sort_field_release_date)
  map.put("gamelist__sort_field_user_rating", Res.string.gamelist__sort_field_user_rating)
  map.put("gamelist__user_rating", Res.string.gamelist__user_rating)
  map.put("gamelist__year_any", Res.string.gamelist__year_any)
  map.put("genre__adventure", Res.string.genre__adventure)
  map.put("genre__arcade", Res.string.genre__arcade)
  map.put("genre__card_board", Res.string.genre__card_board)
  map.put("genre__fighting", Res.string.genre__fighting)
  map.put("genre__hack_and_slash", Res.string.genre__hack_and_slash)
  map.put("genre__indie", Res.string.genre__indie)
  map.put("genre__moba", Res.string.genre__moba)
  map.put("genre__music", Res.string.genre__music)
  map.put("genre__pinball", Res.string.genre__pinball)
  map.put("genre__platform", Res.string.genre__platform)
  map.put("genre__point_and_click", Res.string.genre__point_and_click)
  map.put("genre__puzzle", Res.string.genre__puzzle)
  map.put("genre__quiz", Res.string.genre__quiz)
  map.put("genre__racing", Res.string.genre__racing)
  map.put("genre__rpg", Res.string.genre__rpg)
  map.put("genre__rts", Res.string.genre__rts)
  map.put("genre__shooter", Res.string.genre__shooter)
  map.put("genre__simulation", Res.string.genre__simulation)
  map.put("genre__sport", Res.string.genre__sport)
  map.put("genre__strategy", Res.string.genre__strategy)
  map.put("genre__tactical", Res.string.genre__tactical)
  map.put("genre__tbs", Res.string.genre__tbs)
  map.put("genre__unknown", Res.string.genre__unknown)
  map.put("genre__visual_novel", Res.string.genre__visual_novel)
  map.put("home__empty_section", Res.string.home__empty_section)
  map.put("home__events", Res.string.home__events)
  map.put("home__most_loved_games", Res.string.home__most_loved_games)
  map.put("home__popular_games", Res.string.home__popular_games)
}
